// removed by extract-text-webpack-plugin
module.exports = {"button":"button_37KL0","errorMessage":"errorMessage_3KP5D","loader":"loader_hQcCI","radioAction":"radioAction_1ESSM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageIdentification/style.css
// module id = 188
// module chunks = 0